import React, { useState, useEffect } from 'react';
import { List, Datagrid, TextField, EmailField } from 'react-admin';


export const CryptoKeyList = props => (
	<List {...props} bulkActionButtons={false} >
		<Datagrid rowClick="show">
			<TextField source="address" />
			<TextField source="origin" />
			<TextField source="description" />
			<TextField source="public_key" />
		</Datagrid>
	</List>
);